import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { FiUsers, FiPhone, FiActivity, FiSearch, FiFilter } from "react-icons/fi";

const Workers = () => {
  const [workers, setWorkers] = useState([]);
  const [filteredWorkers, setFilteredWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");

  useEffect(() => {
    fetchWorkers();
  }, []);

  // API se data lana
  const fetchWorkers = async () => {
    try {
      const res = await API.get("/hod/workers");
      if (res.data.success) {
        setWorkers(res.data.data);
        setFilteredWorkers(res.data.data);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Search aur Filter logic
  useEffect(() => {
    let tempWorkers = workers;

    if (searchTerm) {
      tempWorkers = tempWorkers.filter(
        (w) =>
          w.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          w.worker_id.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (statusFilter !== "All") {
      tempWorkers = tempWorkers.filter((w) => {
        if (statusFilter === "Available") return w.active_tasks === 0;
        if (statusFilter === "Busy") return w.active_tasks > 0 && w.active_tasks < 3;
        if (statusFilter === "Overloaded") return w.active_tasks >= 3;
        return true;
      });
    }

    setFilteredWorkers(tempWorkers);
  }, [searchTerm, statusFilter, workers]);

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>
        
        {/* HEADER SECTION */}
        <div style={styles.header}>
          <div>
            <h2 style={styles.title}>Our Workforce 👷‍♂️</h2>
            <p style={styles.subtitle}>View and manage your team’s availability and task load.</p>
          </div>
          <div style={styles.statBadge}>
            Total Team: {workers.length}
          </div>
        </div>

        {/* SEARCH & FILTER BAR */}
        <div style={styles.controls}>
          <div style={styles.searchBox}>
            <FiSearch style={styles.icon} />
            <input
              type="text"
              placeholder="Search by name or badge id..."
              style={styles.input}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div style={styles.filterBox}>
            <FiFilter style={styles.icon} />
            <select
              style={styles.select}
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="All">All Status</option>
              <option value="Available">Available</option>
              <option value="Busy">Busy</option>
              <option value="Overloaded">Overloaded</option>
            </select>
          </div>
        </div>

        {/* TABLE CARD */}
        <div style={styles.tableCard}>
          {loading ? (
            <div style={styles.emptyState}>🔄 Syncing workforce data...</div>
          ) : filteredWorkers.length === 0 ? (
            <div style={styles.emptyState}>
              <FiUsers size={40} color="#CBD5E1" />
              <p>No matching workers found.</p>
            </div>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr style={styles.theadRow}>
                  <th style={styles.th}>BADGE ID</th>
                  <th style={styles.th}>WORKER NAME</th>
                  <th style={styles.th}>CONTACT</th>
                  <th style={styles.th}>ACTIVE TASKS</th>
                  <th style={styles.th}>CURRENT STATUS</th>
                </tr>
              </thead>
              <tbody>
                {filteredWorkers.map((worker) => (
                  <tr key={worker.id} style={styles.tr}>
                    <td style={styles.td}>
                      <span style={styles.badge}>{worker.worker_id}</span>
                    </td>
                    <td style={styles.td}>
                      <div style={styles.nameContainer}>
                        <div style={styles.avatar}>{worker.name.charAt(0)}</div>
                        <strong>{worker.name}</strong>
                      </div>
                    </td>
                    <td style={styles.td}>
                      <div style={styles.phoneBox}>
                        <FiPhone size={14} /> {worker.phone || "---"}
                      </div>
                    </td>
                    <td style={styles.td}>
                      <span style={styles.taskCount}>
                        <FiActivity size={14} /> {worker.active_tasks} Tasks
                      </span>
                    </td>
                    <td style={styles.td}>
                      <LoadStatus count={worker.active_tasks} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const LoadStatus = ({ count }) => {
  const style = count === 0 ? { bg: "#ECFDF5", text: "#10B981", label: "Available" } : 
                count < 3 ? { bg: "#FFFBEB", text: "#F59E0B", label: "Busy" } : 
                { bg: "#FEF2F2", text: "#EF4444", label: "Overloaded" };

  return (
    <span style={{ ...styles.status, backgroundColor: style.bg, color: style.text }}>
      {style.label}
    </span>
  );
};

const styles = {
  layout: { display: "flex", background: "#F8FAFC", minHeight: "100vh" },
  mainContent: { marginLeft: "260px", padding: "40px", flex: 1, fontFamily: "'Poppins', sans-serif" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" },
  title: { margin: 0, fontSize: "26px", fontWeight: "700", color: "#1E293B" },
  subtitle: { color: "#64748B", fontSize: "14px", marginTop: "5px" },
  statBadge: { background: "#D4AF37", color: "#000", padding: "8px 20px", borderRadius: "10px", fontWeight: "700" },
  
  controls: { display: "flex", gap: "15px", marginBottom: "25px" },
  searchBox: { flex: 1, position: "relative", display: "flex", alignItems: "center" },
  filterBox: { width: "200px", position: "relative", display: "flex", alignItems: "center" },
  icon: { position: "absolute", left: "15px", color: "#94A3B8" },
  input: { width: "100%", padding: "12px 15px 12px 45px", borderRadius: "12px", border: "1px solid #E2E8F0", outline: "none", fontSize: "14px" },
  select: { width: "100%", padding: "12px 15px 12px 45px", borderRadius: "12px", border: "1px solid #E2E8F0", outline: "none", background: "#FFF", fontSize: "14px", cursor: "pointer", appearance: "none" },

  tableCard: { background: "#FFF", borderRadius: "20px", padding: "20px", border: "1px solid #F1F5F9", boxShadow: "0 4px 15px rgba(0,0,0,0.02)" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "15px", color: "#64748B", fontSize: "12px", borderBottom: "1px solid #F1F5F9", textTransform: "uppercase", letterSpacing: "0.5px" },
  td: { padding: "16px 15px", fontSize: "14px", borderBottom: "1px solid #F8FAFC" },
  
  nameContainer: { display: "flex", alignItems: "center", gap: "10px" },
  avatar: { width: "32px", height: "32px", background: "#D4AF3720", color: "#D4AF37", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" },
  badge: { background: "#F1F5F9", padding: "4px 10px", borderRadius: "6px", fontWeight: "600", fontSize: "12px", color: "#475569" },
  status: { padding: "5px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" },
  phoneBox: { display: "flex", alignItems: "center", gap: "8px", color: "#64748B" },
  taskCount: { display: "flex", alignItems: "center", gap: "6px", color: "#1E293B", fontWeight: "500" },
  emptyState: { textAlign: "center", padding: "60px", color: "#94A3B8" }
};

export default Workers;